const stablecoinData = [
  {
    "region": "Americas",
    "coins": [
      {
        "name": "RLUSD",
        "issuer": "rMxCKbEDwqr76QuheSUMdEGf4B9xJ8m5De",
        "currency": "RLUSD",
        "unitsIssued": 65905296,
        "navPrice": 1,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "New York",
        "lat": 40.7128,
        "lng": -74.0060
      },
      {
        "name": "BBRL",
        "issuer": "rH5CJsqvNqZGxrMyGaqLEoMWRYcVTAPZMt",
        "currency": "BBRL",
        "unitsIssued": 1396400,
        "navPrice": 1,
        "navPriceCurrency": "BRL",
        "exchangeRate": 0.01163,
        "city": "São Paulo",
        "lat": -23.5505,
        "lng": -46.6333
      },
      {
        "name": "Circle USDC",
        "issuer": "rcEGREd8NmkKRE8GE424sksyt1tJVFZwu",
        "currency": "USDC",
        "unitsIssued": 7000000,
        "navPrice": 1,
        "navPriceCurrency": "USD",
        "exchangeRate": 1,
        "city": "New York",
        "lat": 40.7128,
        "lng": -74.0060
      }
    ]
  },
  {
    "region": "Europe, Middle East & Africa",
    "coins": [
      {
        "name": "EUROP",
        "issuer": "rMkEuRii9w9uBMQDnWV5AA43gvYZR9JxVK",
        "currency": "EUROP",
        "unitsIssued": 41373,
        "navPrice": 1,
        "navPriceCurrency": "EUR",
        "exchangeRate": 1.08,
        "city": "Paris",
        "lat": 48.8566,
        "lng": 2.3522
      }
    ]
  },
  {
    "region": "Asia-Pacific",
    "coins": []
  }
];

export default stablecoinData;